import axios from "axios";
import { isDebug, utils } from "../utils";

const createInstance = () => {
  const baseURL = process.env.REACT_APP_API_URL
  const headers = {
    "ngrok-skip-browser-warning": true, // 외부 접근
    "Access-Control-Allow-Credentials": true, // 외부 접근
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  const _instance = axios.create({
    baseURL,
    headers,
  });

  const instance = axios.create({
    baseURL,
    headers,
  });

  const debugPrint = false;

  // instance.interceptors.request.use(async config => config);

  instance.interceptors.request.use(async config => {
    const accessToken = sessionStorage.getItem("access");
    const refreshToken = sessionStorage.getItem("refresh");
    const fpToken = sessionStorage.getItem("fp");

    /** 1. 토큰 체크 */
    // const token = useUser.getState().token;
    const decodedToken = accessToken
      ? utils.api.decodeJWT(accessToken)
      : null;

    if (decodedToken && decodedToken.exp) {
      const expUTCDate = decodedToken.exp * 1000;
      const currentUTCDate = Date.now();

      // set token
      config.headers.access = accessToken;
      if (isDebug() && debugPrint) console.log('[axios] [exp]', expUTCDate);
      if (isDebug() && debugPrint) console.log('[axios] [current]', currentUTCDate);

      if (expUTCDate <= currentUTCDate) {
        // access token 만료되면 자동 갱신 (silence refresh)
        try {
          const response = await _instance.post('/member/access_token', null, {
            headers: {
              refresh: refreshToken,
              fp: fpToken,
            },
          });
          const access = response.headers.access;
          sessionStorage.setItem("access", access);

          // set token
          config.headers.access = access;
          if (isDebug() && debugPrint) console.log('[axios get access token]', access);

          // 다시 시도
        } catch (error) {
          /* TODO 갱신 실패 시 예외처리 */
          console.log('[axios get access token error]', error);
          console.log('[axios get access token error]', JSON.stringify(accessToken));
        }
      }
    }

    if (isDebug() && debugPrint) console.debug('[axios request]', JSON.stringify(config, null, 2));

    /** 2. 데이터 정리 */
    if (config.data) {
      Object.keys(config.data).forEach(key => {
        // undefined, null, ''인 데이터는 key에서 제외함
        const conf = [undefined, null, ''];
        if (conf.includes(config.data[key])) {
          delete config.data[key];
        }
      });
    }

    return config;
  });

  instance.interceptors.response.use(
    config => {
      if (isDebug() && debugPrint) console.debug('[axios response]', JSON.stringify(config, null, 2));

      return config;
    },
    error => {
      console.debug('[axios error]', JSON.stringify(error, null, 2));
      console.debug(
        '[axios response error]',
        JSON.stringify(error.response, null, 2),
      );

      return Promise.reject(error);
    },
  );

  return instance;
};

export default createInstance();
